import { Injectable } from '@angular/core';

@Injectable()
export class DateProvider {
  public now() {
    return new Date();
  }
}
